module.exports = __webpack_public_path__ + "img/jd.61630145.png";